/**
 * How many stock market 'ticks' before a 'cycle' is triggered.
 * A 'tick' is whenver stock prices update
 */
export const TicksPerCycle = 75;
